
import { t } from '@/i18n'
import mqtt from '@/utils/mqtt'

const MQTT_RECONNECT_TIMEOUT = 5000
const DEFAULT_CLOSED_DESCRIPTION = '商家临时打烊，请稍后再来'

export default {
  data () {
    return {
      mqttReconnecting: false,
      mqttReconnectTimer: null,
      mqttReconnectMessage: null,
      shopStatusUpdating: false
    }
  },
  computed: {
    mqttButtonType () {
      if (this.mqttReconnecting) return 'warning'
      return this.mqttState ? 'success' : 'danger'
    }
  },
  watch: {
    mqttState (connected) {
      if (connected && this.mqttReconnecting) {
        this.finishMqttReconnect(true)
      }
    }
  },
  beforeDestroy () {
    this.clearMqttReconnectTimer()
    if (this.mqttReconnectMessage) this.mqttReconnectMessage.close()
  },
  methods: {
    handleMqttStatusClick () {
      if (this.mqttState || mqtt.isConnected()) {
        this.$store.state.app.mqttState = true
        this.$message.success(t('指令服务器连接正常'))
        return
      }
      if (this.mqttReconnecting) return

      this.mqttReconnecting = true
      this.mqttReconnectMessage = this.$message.info(t('正在尝试重新连接指令服务器'))
      if (!mqtt.reconnectNow()) {
        this.finishMqttReconnect(false)
        return
      }

      this.clearMqttReconnectTimer()
      this.mqttReconnectTimer = setTimeout(() => {
        if (this.mqttState || mqtt.isConnected()) {
          this.$store.state.app.mqttState = true
          this.finishMqttReconnect(true)
        } else {
          this.finishMqttReconnect(false)
        }
      }, MQTT_RECONNECT_TIMEOUT)
    },
    finishMqttReconnect (connected) {
      if (!this.mqttReconnecting) return
      this.clearMqttReconnectTimer()
      if (this.mqttReconnectMessage) {
        this.mqttReconnectMessage.close()
        this.mqttReconnectMessage = null
      }
      this.mqttReconnecting = false
      if (connected) {
        this.$message.success(t('指令服务器重连成功'))
      } else {
        this.$message.warning(t('暂未连接，系统将继续自动重连，请检查网络或服务器'))
      }
    },
    clearMqttReconnectTimer () {
      if (this.mqttReconnectTimer) {
        clearTimeout(this.mqttReconnectTimer)
        this.mqttReconnectTimer = null
      }
    },
    async handleShopStatusClick () {
      const shop = this.currentShop
      if (!shop) {
        this.$message.warning(t('未获取到当前商铺状态'))
        return
      }
      if (this.shopStatusUpdating) return

      const isManualClosed = String(shop.manual_closed || '0') === '1'
      try {
        if (isManualClosed) {
          await this.$confirm(
            t(shop.manual_closed_desc || DEFAULT_CLOSED_DESCRIPTION),
            t('商铺已主动打烊'),
            {
              confirmButtonText: t('恢复营业'),
              cancelButtonText: t('取消'),
              type: 'warning'
            }
          )
          await this.updateShopManualClosed(false, '')
          return
        }

        if (!this.shopOpenState.isOpen) {
          await this.$alert(t(this.shopOpenState.reason), t('当前未营业'), {
            confirmButtonText: t('知道了'),
            type: 'warning'
          })
          return
        }

        const result = await this.$prompt(t('请输入主动打烊原因'), t('主动打烊'), {
          confirmButtonText: t('确认打烊'),
          cancelButtonText: t('取消'),
          inputValue: DEFAULT_CLOSED_DESCRIPTION,
          inputPlaceholder: DEFAULT_CLOSED_DESCRIPTION,
          inputValidator: value => {
            return String(value || '').trim().length <= 100 || '打烊原因不能超过100个字'
          }
        })
        await this.updateShopManualClosed(true, String(result.value || DEFAULT_CLOSED_DESCRIPTION).trim())
      } catch (action) {
        // 取消或关闭弹框时不提示
        if (action !== 'cancel' && action !== 'close') {
          console.warn('商铺营业状态弹框异常', action)
        }
      }
    },
    async updateShopManualClosed (manualClosed, description) {
      this.shopStatusUpdating = true
      try {
        const res = await this.$store.dispatch('fetchSetShopManualClosed', {
          shopId: this.currentShop.shop_id,
          manualClosed,
          description
        })
        if (Number(res.data.status) === 1) {
          this.$message.success(t(res.data.msg))
        } else {
          this.$message.error(t(res.data.msg || '营业状态更新失败'))
        }
      } catch (error) {
        this.$message.error(t('营业状态更新失败，请检查网络'))
      } finally {
        this.shopStatusUpdating = false
      }
    }
  }
}
